import { useContext } from 'react';
import { PlayerDto, UserGroup } from '../../../../../types/dtos.types';
import { GroupContext } from '../../../../../App';

interface AccordionPlayerDataProps {
  player: PlayerDto;
  userGroups: [UserGroup];
}

const AccordionPlayerData = (props: AccordionPlayerDataProps) => {
  const { groupId } = useContext(GroupContext);
  const player = props.player;
  const userGroup = props.userGroups.filter(
    (group) => group.groupId === groupId
  );
  const isBannedFromGroup = userGroup[0].isBanned;
  return (
    <div className="container-fluid header-result container-fluid d-flex  align-items-center">
      <div className="p-2 flex-grow-1 breadcrumb-title">
        <span>{player.name}</span>
        {isBannedFromGroup ? (
          <span className="mx-2">
            <i className={`bi bi-slash-circle text-danger`}></i>
          </span>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default AccordionPlayerData;
